import React, { Component } from 'react'
import { Form, Input, FormGroup } from '@softwaredev_cegeka/stix-form'
import { Button, Card, Grid, Navbar } from '@softwaredev_cegeka/stix-core'
import logo from '../assets/images/logo-white.png'
import { fakeAuth } from './Authroute'

class Login extends Component {
    state = { validated: false }

    handleSubmit = event => {
        const form = event.currentTarget
        event.preventDefault()
        event.stopPropagation()
        if (form.checkValidity() === false) {
            this.setState({ validated: true })
        } else {
            let history = this.props.history
            let location = this.props.location
            let { from } = location.state || { from: { pathname: '/' } }
            fakeAuth.authenticate(() => {
                history.replace(from)
            })
        }
    }

    render() {
        return (
            <>
                <Navbar
                    fixed={'top'}
                    sticky={'top'}
                    bg={'primary'}
                    variant={'dark'}
                >
                    <Navbar.Brand href={'/'}>
                        <img src={logo} alt={'Heimdallr logo'} />
                    </Navbar.Brand>
                </Navbar>
                <Grid.Container>
                    <Grid.Col
                        lg={{ span: 6, offset: 3 }}
                        md={{ span: 6, offset: 3 }}
                    >
                        <Card body>
                            <Card.Title>Login</Card.Title>
                            <Form
                                noValidate
                                validated={this.state.validated}
                                onSubmit={this.handleSubmit}
                            >
                                <FormGroup>
                                    <Input
                                        label={'username'}
                                        srOnly
                                        placeholder={'username'}
                                        required
                                        feedback={'please provide a user name'}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        type={'password'}
                                        label={'password'}
                                        srOnly
                                        placeholder={'password'}
                                        required
                                        feedback={
                                            'please provide a correct password'
                                        }
                                    />
                                </FormGroup>
                                <Button.Toolbar>
                                    <Button variant={'secondary'} type="submit">
                                        Login
                                    </Button>
                                    <Button variant="link">
                                        Forgot password
                                    </Button>
                                </Button.Toolbar>
                            </Form>
                        </Card>
                    </Grid.Col>
                </Grid.Container>
            </>
        )
    }
}

export default Login
